import React from "react";
import {RouteObject} from 'react-router-dom';
import AdminLogin from "../../pages/LADLogin/AdminLogin";
import NewPassword from "../../pages/LADLogin/NewPassword";
import ForgotPassword from "../../pages/LADLogin/ForgotPassword";
import ForgotRestPassword from "../../pages/LADLogin/ForgotRestPassword";
import QRCodeComponent from "../../pages/LADLogin/QRCodeComponent";
import TwoFactorAuth from "../../pages/LADLogin/TwoFactorAuth";

const token = localStorage.getItem('token');

const AdminLoginRoutes : RouteObject[] = [
    {
        path:'/',
        element:<AdminLogin/>,
    },
    {
        path: 'newpassword',
        element: <NewPassword/>
    },
    {
        path: 'forgotpassword',
        element: <ForgotPassword/>
    },
    {
        path: 'qrcode',
        element:<QRCodeComponent/>
    },
    {
        path: 'twofactorauth',
        element:<TwoFactorAuth/>
    },
    {
        path: '/SuperAdmin_login/reset_password_SuperAdmin/:token',
        element: <ForgotRestPassword/>
    },
    {
        path: '/Admin_login/reset_password_Admin/:token',
        element: <ForgotRestPassword/>
    },
    {
        path: '/Employee_login/reset_password_Employee/:token',
        element: <ForgotRestPassword/>
    }
]

export default AdminLoginRoutes;